import React, {useState,useEffect} from "react";
import "./Chat.scss";
import { CustomerServiceOutlined,SendOutlined } from '@ant-design/icons';
import thumb from "../../assets/images/icon_user.png";
import {postMessageApi} from "../../Services/apis";
import {NavLink} from "react-router-dom";

function ChatFloat(){

    const [visibleChat,set_visibleChat] = useState(false)

    const toggleChat = ()=>{
        set_visibleChat(!visibleChat);
    }

    const ClientCard = ()=>{
        return(
            <div className="chat-box-main-body-item-client">
                <p>سلام مکمل سفارش دادم از داروخانه شما</p>
                <span>1402/03/04 12:34</span>
            </div>
        )
    }

    const OwnerCard = ()=>{
        return(
            <div className="chat-box-main-body-item-client">
                <p>سلام مکمل سفارش دادم از داروخانه شما</p>
                <span>1402/03/04 12:34</span>
            </div>
        )
    }



    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState("");


    useEffect(() => {
        let token = localStorage.getItem("token")
        const socket = new WebSocket(`wss://dr-hamzavipharmacy-test.apluss.ir/ws/chats/?token=${token}`);
        socket.onopen = () => {
            console.log("WebSocket connection established.");
        };
        socket.onmessage = (event) => {
            const message = JSON.parse(event.data);
            setMessages((prevMessages) => [...prevMessages, message]);
        };
        socket.onclose = () => {
            console.log("WebSocket connection closed.");
        };
        return () => {
            socket.close();
        };
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (inputValue.trim() === "") {
            return;
        }

        const message = {
            content: inputValue,
        };
        try {
            await postMessageApi(message)
            setInputValue("");
        } catch (error) {
            console.error(error);
        }
    };

    return(
        <div className="chat-box-container">
            <div className="chat-box-wrapper">
                <div className="chat-box-badge" onClick={e=>{
                    toggleChat()
                }}>
                    <CustomerServiceOutlined />
                </div>
                {visibleChat?<div className="chat-box-main">
                    <div className="chat-box-main-header">

                        <div className="chat-box-main-header-text">
                            {/*<NavLink exact="true" className="nav-link logoheader mx-3" to='/' >REACT.COM*/}
                            {/*</NavLink>*/}
                            <span className="chat-box-main-header-text-title">به داروخانه دکتر فتوحی خوش آمدید</span>
                            <span className="chat-box-main-header-text-subtitle">پاسخگوی سوالات شما هستیم</span>
                        </div>

                        <div className="chat-box-main-header-thumb">
                            <img src="https://api.raychat.io/uploads/users-avatar/e8254f47-2774-4568-85de-daefaccaa489.jpg" alt=""/>
                        </div>

                    </div>
                    <div className="chat-box-main-body">
                        <div className="chat-box-main-body-item-client">
                            <p>سلام مکمل سفارش دادم از داروخانه شما</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-owner">
                            <p>سلام , شماره سفارش و بفرمایید</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-client">
                            <p>شماره سفارش ۱۴۰۸۹۲۳۴</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-owner">
                            <p>بله خدمتتون ارسال شده</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-client">
                            <p>سلام مکمل سفارش دادم از داروخانه شما</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-owner">
                            <p>سلام , شماره سفارش و بفرمایید</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-client">
                            <p>شماره سفارش ۱۴۰۸۹۲۳۴</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                        <div className="chat-box-main-body-item-owner">
                            <p>بله خدمتتون ارسال شده</p>
                            <span>1402/03/04 12:34</span>
                        </div>
                    </div>
                    <div className="chat-box-main-footer">
                        <input type="text" name="" id="" placeholder="اینجا تایپ کنید..."/>
                        <SendOutlined />
                    </div>
                </div>:null}

            </div>

        </div>
    )
}

export default ChatFloat
